import {
  HISTORICO_LOADING,
  HISTORICO_SUCCESS,
  HISTORICO_ERROR,
  CLEAR_HISTORICO_DATA,
} from "../../constants/ActionTypes";

import historicoInitialState from "../initialStates/historicoInitialState";

const historico = (state, { payload, type }) => {
  switch (type) {
    case HISTORICO_LOADING:
      return {
        ...state,
        historico: {
          ...state.historico,
          error: false,
          loading: true,
        },
      };
    case HISTORICO_SUCCESS:
      return {
        ...state,
        historico: {
          ...state.historico,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case HISTORICO_ERROR:
      return {
        ...state,
        historico: {
          ...state.historico,
          error: payload,
          loading: false,
        },
      };

    case CLEAR_HISTORICO_DATA:
      return {
        ...state,
        historico: historicoInitialState,
      };

    default:
      return state;
  }
};

export default historico;
